import api from '../../../services/api';
import { PendenciaKanban } from './types';
import { mapPendenciaFromBackend, PendenciaBackend } from './utils';

export const fetchPendenciasKanban = async (id_proposta: number): Promise<PendenciaKanban[]> => {
    try {
        if (!id_proposta || isNaN(id_proposta)) {
            throw new Error('ID da proposta inválido');
        }

        const response = await api.get(`/pendencias/kanban/${id_proposta}`);

        if (response.data.status !== 'success') {
            throw new Error(response.data.message || 'Erro ao buscar pendências');
        }

        const pendenciasBackend: PendenciaBackend[] = response.data.result || [];

        const pendenciasMapeadas = pendenciasBackend.map(mapPendenciaFromBackend);

        return pendenciasMapeadas;
    } catch (error: any) {
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        
        if (error.message) {
            throw error;
        }
        
        throw new Error('Não foi possível carregar as pendências. Tente novamente.');
    }
};

